"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCustomerAccountMobileOpen = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackCustomerAccountMobileOpen(eventLabel) {
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: 'JS_Event',
        eventCategory: 'CustomerAccount',
        eventAction: 'Open',
        eventLabel,
        nonInteraction: false,
    });
}
exports.trackCustomerAccountMobileOpen = trackCustomerAccountMobileOpen;
//# sourceMappingURL=trackCustomerAccountMobileOpen.js.map